import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const DemoLoginPage = lazy(() => import('../pages/demo-login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const ImprintPage = lazy(() => import('../pages/imprint/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/demo',
    element: <DemoLoginPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/datenschutz',
    element: <PrivacyPage />
  },
  {
    path: '/impressum',
    element: <ImprintPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
